import React, { useState, useEffect, useContext } from "react";
import { toast, ToastContainer, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastAppType } from "../../common/constant/enum/toastAppType";
import { ToastAppMsgContext } from "../../context/toastApp.Context";

const ToastAppMsg = () => {
  const {ToastData} = useContext(ToastAppMsgContext)
  useEffect(() => {
    if (ToastData.Message) {
      let style = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      } as ToastOptions;
      switch (ToastData.Type) {
        case ToastAppType.Error:
          toast.error("Error: " + ToastData.Message, style);
          break;
        case ToastAppType.Info:
          toast.info(ToastData.Message, style);

          break;
        case ToastAppType.Success:
          toast.success(ToastData.Message, style);
          break;
        default:
          toast(ToastData.Message, style);
          break;
      }
    }
  }, [ToastData])
  return (
    <>
      <ToastContainer
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
    </>);
};
export default ToastAppMsg;
